import ComingSoon from "@/components/cre/ComingSoon";
import { AlertTriangle } from "lucide-react";

export function GovernanceRails() {
  return (
    <div className="cre-surface rounded-sm p-6">
      <div className="flex items-center gap-2">
        <AlertTriangle className="h-4 w-4 text-amber-300" strokeWidth={1.5} />
        <span className="cre-overline text-amber-300">
          Governance rails — enterprise only
        </span>
      </div>
      <div className="mt-3 grid grid-cols-1 md:grid-cols-3 gap-3 text-sm">
        <div className="border border-white/10 rounded-sm p-3">
          <div className="font-medium text-zinc-200">Ledger anchor</div>
          <div className="text-xs text-zinc-500 mt-1">
            Hash-chain anchored into an external append-only ledger.
          </div>
          <div className="mt-2">
            <ComingSoon label="Blockchain ledger" variant="ghost" />
          </div>
        </div>
        <div className="border border-white/10 rounded-sm p-3">
          <div className="font-medium text-zinc-200">RL-tuned weights</div>
          <div className="text-xs text-zinc-500 mt-1">
            Consensus weights adapt from historical outcomes.
          </div>
          <div className="mt-2">
            <ComingSoon label="Reinforcement learning" variant="ghost" />
          </div>
        </div>
        <div className="border border-white/10 rounded-sm p-3">
          <div className="font-medium text-zinc-200">Execution actuator</div>
          <div className="text-xs text-zinc-500 mt-1">
            Production execution requires enterprise RBAC, approvals, and
            rollback safeguards — available only in enterprise deployments.
          </div>
          <div className="mt-2">
            <ComingSoon label="Live execution locked" variant="ghost" />
          </div>
        </div>
      </div>
    </div>
  );
}
